<template>
    <nav class="bg-first p-4" :class="config.env">
        <div class="container">
            <div class="d-flex align-items-center flex-wrap mx-4">
                <div class="col-12 col-sm-6 text-center text-sm-start mb-4 mb-sm-0">
                    <a href="https://www.atb.bergamo.it/it">
                        <img :src="require(`@/assets/img/tenants/${omsApiKey}.svg`)" alt="tenant logo">
                    </a>
                </div>
                <div class="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-end align-items-center">
                    <i class="fa-regular fa-user bg-white rounded-pill p-2 me-2" data-bs-toggle="dropdown"></i>
                    <span data-bs-toggle="dropdown" class="text-white text-nowrap" role="button">
                        {{ account.name }} {{ account.surname }}
                    </span>
                    <ul class="dropdown-menu dropdown-menu-end dropdowns">
                        <li>
                            <router-link class="dropdown-item" to="/dashboard">
                                <i class="fa-solid fa-gauge-high me-2"></i>
                                {{ $t('Navbar.dropdown.Dashboard') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link class="dropdown-item" to="/dashboard/account">
                                <i class="fa-solid fa-user me-2"></i>
                                {{ $t('Navbar.dropdown.Account') }}
                            </router-link>
                        </li>
                        <li>
                            <span class="dropdown-item" @click="this.$store.dispatch('logout')">
                                <i class="fa-solid fa-sign-out-alt me-2"></i>
                                {{ $t('Navbar.dropdown.logout') }}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
    name: 'NavbarComp',
    computed: {
        ...mapState(['config', 'account']),
        ...mapGetters(['omsApiKey'])
    }
}
</script>

<style lang="scss" scoped>
    nav {
        img {
            width: 40%;
        }
    }

    @media screen and (max-width: 992px) {
        header {
            img {
                width: 75%;
            }
        }
    }
</style>